<template>
  <div class="video-wrapper" :class="[videoPlaying && 'is-playing']" v-if="detail.videoUrl || startTime">
    <video id="video" :class="isShow ? 'isShow' : ''" ref="videoRef" class="video video-js" v-if="detail.videoUrl" :src="detail.videoUrl" x5-video-player-type="h5-page" playsinline webkit-playsinline="true" controls loop mtt-playsinline=“true” raw-controls></video>
    <div class="poster-img"  v-if="!videoPlaying">
      <img :src="detail.coverUrl || detail.imgUrl || ''" @error="imgError" alt="">
    </div>
    <div class="video-poster" v-if="!videoPlaying">
      <span class="status" v-if="startTime && detail.liveStatus != 0" :class="'status-' + detail.liveStatus">{{$tc('forum.status', detail.liveStatus - 1)}}</span>
      <div class="play-icon" :class="[!startTime && 'video-play-icon']" v-if="!timeSize && detail.videoUrl" @click="videoPlay">
        <i class="iconfont" :class="[detail.liveStatus === 2 ? 'iconyuyuechexiao' : 'iconbofang']"></i>
        <span v-if="detail.liveStatus">{{$tc('forum.status', detail.liveStatus - 1)}}</span>
      </div>
      <div class="count-down" v-if="timeSize">
        <span>{{$tc('forum.notice')}}</span>
        <p v-if="parseInt(timeSize[0]) != 0">{{parseInt(timeSize[0])}}{{$tc('home.days', parseInt(timeSize[0]))}} {{timeSize[1]}}:{{timeSize[2]}}:{{timeSize[3]}}</p>
        <p v-else>{{timeSize[1]}}:{{timeSize[2]}}:{{timeSize[3]}}</p>
      </div>
    </div>

    <div class="video_ai_tag_box" v-if="detail.videoAiLabels && detail.videoAiLabels.length">
        <div class="ai_tips_box">
            <div class="ai_tags_tips">{{detail.videoAiLabels[0].labelName}}</div>
            <div class="ai_tags_arrow" v-if="detail.videoAiLabels.length > 1"></div>
        </div>
        <div class="ai_tags_info hide" v-if="detail.videoAiLabels.length > 1">
            <div class="ai_tag" v-for="item in detail.videoAiLabels.slice(1, detail.videoAiLabels.length)" :key="item.labelId">
                {{item.labelName}}
            </div>
        </div>
    </div>
  </div>
</template>

<script>
// 手机调试工具
// import VConsole from 'vconsole'
// const vConsole = new VConsole()

import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import zhCN from 'video.js/dist/lang/zh-CN.json';
// 使用 addLanguage 注册中文
videojs.addLanguage('zh-CN', zhCN);

export default {
  name: 'Video',
  data () {
    return {
      timeSize: null,
      startTime: '',
      isShow: false,
      mianVieoPlayer: null,
      videoPlaying: false
    }
  },
  props: ['detail'],
  mounted () {
    if (this.detail.liveStatus === 2 && !this.detail.videoUrl) {
      this.detail.liveStatus = 3
    }
    this.startTime = this.detail.liveOpenTime || this.detail.liveStartTime
    if (this.detail.liveStatus === 0 && this.startTime && this.startTime > this.detail.systemCurrentTime) {
      this.countDown()
    } else if (this.detail.liveStatus === 0) {
      this.detail.liveStatus = 1
    }
    this.initMainVideo()
    this.$Common.initContentVideo()
  },
  methods: {
    countDown () {
      if (this.detail.liveStatus === 0) {
        let serverTime = this.detail.systemCurrentTime || new Date().getTime()
        this.timeSize = this.$Common.countDown(this.startTime, serverTime)
        const timeId = setInterval(() => {
          serverTime = serverTime + 1000
          this.timeSize = this.$Common.countDown(this.startTime, serverTime)
          if (!this.timeSize) {
            this.detail.liveStatus = 1
            clearInterval(timeId)
          }
        }, 1000)
      }
    },
    initMainVideo: function () {
        var videoWrapper = $('.video-wrapper')
        var mainVideo = videoWrapper.find('#video')
        if (mainVideo && mainVideo.length && mainVideo[0].src) {
            var self = this
            this.mianVieoPlayer = videojs(mainVideo[0], {
              language: 'zh-CN',
              controls: true,
              playbackRates: [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2],
              sources: [{
                  src: mainVideo[0].src
              },
              {
                  src: mainVideo[0].src,
                  type: 'video/mp4'
              }]
            })
        }
    },
    
    videoPlay () {
      // const video = document.querySelector('.video')
      // video.style.display = 'block'
      // video.play()
      // document.querySelector('.poster-img').style.display = 'none'
      // document.querySelector('.video-poster').style.display = 'none'
      this.mianVieoPlayer.play();
      this.videoPlaying = true
      var videoWrapper = $('.video-wrapper');
      var videoTags = videoWrapper.find('.video_ai_tag_box');
      if (videoTags && videoTags.length) {
          videoWrapper.find('.video-js').append(videoTags);
      }
      
    },
    imgError (e) {
      e.target.src = require('../assets/img/default_img169.jpg')
    }
  },
  beforeDestroy () {
    if (this.$refs.videoRef) {
      const videoRef = this.$refs.videoRef
      videoRef.style.display = 'none'
      videoRef.setAttribute('class', 'isShow')
      // 隐藏父盒子video-wrapper
      this.$el.display = 'none'
      // 视频问题解决尝试1 修改传过来的对象的属性值
      this.detail.videoUrl = ''
      // 视频问题解决尝试2 修改video的显示状态
      this.isShow = true
      // 清除调试工具
      // vConsole.destroy()
    }
  }
}
</script>

<style lang="scss" scoped>
.video-wrapper {
  font-size: 0;
  width: 100%;
  height: 56.296vw;
  position: relative;
  background-color: #000;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
    background-color: #000;
    display: none;
  }
  .video-js {
    width: 100%;
    height: 100%;
    background-color: #000;
    display: none;
  }
  .poster-img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    img {
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .status {
    color: #fff;
    position: absolute;
    left: 7.407vw;
    top: 2.778vw;
    padding: 0 2.222vw;
    font-size: 5.37vw;
    height: 7.778vw;
    display: flex;
    align-items: center;
    transform: scale(0.5);
    transform-origin: left top;
    z-index: 2;
    background-color: #2fb23b;
    &.status-1 {
      background-color: #f9353e;
    }
    &.status-2,
    &.status-3 {
      background-color: #1756d2;
    }
  }
  .video-poster {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    .play-icon {
      position: absolute;
      width: 24.074vw;
      height: 9.259vw;
      background-color: #4b4b4b;
      border-radius: 4.63vw;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      i {
        font-size: 4.3vw;
        color: #fff;
        margin-right: 0.5vw;
      }
      span {
        font-size: 3.5vw;
        color: #fff;
      }
      &.video-play-icon {
        background: none;
        i {
          font-size: 15vw;
        }
      }
    }
    .count-down {
      color: #fff;
      text-align: center;
      line-height: 1.4;
      span {
        font-size: 3.796vw;
        display: block;
        margin-bottom: 0.926vw;
      }
      p {
        font-size: 5.926vw;
      }
    }
  }
  .isShow {
    display: none !important;
    visibility: 0 !important;
    width: 100%;
    height: 100%;
    background-color: #000;
  }
}

.is-playing.video-wrapper video, .is-playing.video-wrapper .video-js {
    display: block;
}

.video-player-wrapper .vjs-news-main-download-label {
    font-size: 0.5rem;
    line-height: 1;
    padding: 0 0.2em;
    pointer-events: none;
}
.video-player-wrapper .vjs-news-main-download .vjs-icon-placeholder {
    display: none;
}

.vjs-menu-button-popup .vjs-menu .vjs-menu-content {
    max-height: 20em !important;
}
</style>
